import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listProvince: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setListProvince: (state, action) => {
      state.listProvince = action.payload;
    },
  },
});

// actions
export const { setListProvince } = filterSlice.actions;
// selector

export const selectListProvince = (state) => state.filterReducer.listProvince;

// reducer

const filterReducer = filterSlice.reducer;
export default filterReducer;
